<template>
  <v-app>
    <router-view />
    <v-row>
      <v-col class="d-flex align-center justify-center">
        <v-alert
          border="left"
          colored-border
          style="position:fixed; display:none; line-height:2;  width:50vw; bottom:15px; z-index:999"
          id="updateNotification"
          color="#F15A24"
          icon="$info"
        >
        <v-row class="text-center">
          <v-col class="grow">
              Existe uma nova versão do MyLegis disponível.
            </v-col>
            <v-col class="shrink">
              <v-btn @click="reloadPage()"  color="#F15A24" dark>Atualizar</v-btn>
            </v-col>
          </v-row>
      </v-alert>
      </v-col>
    </v-row>
    <FloatingChat />
  </v-app>
</template>

<style>
body { overflow:hidden}

.v-app-bar {
  padding-top: env(safe-area-inset-top) !important;
  height: calc(64px + env(safe-area-inset-top)) !important;
}
.v-navigation-drawer, .v-dialog {
  padding-top: env(safe-area-inset-top) !important;
}
/* Remove o padding do body que você adicionou */
body {
  padding-top: 0;
}
html { 
  overflow-y:auto !important;
}


:root {
  --safe-area-inset-top: env(safe-area-inset-top);
  --safe-area-inset-bottom: env(safe-area-inset-bottom);
}

#app {
  padding-top: var(--safe-area-inset-top);
  padding-bottom: var(--safe-area-inset-bottom);
  height: 100%;
}

/* iOS: somente a home zera o padding-top do #app (a v-app-bar dela
   cobre a área do notch / Dynamic Island com o fundo laranja).
   Todas as outras telas mantêm padding-top = safe-area-inset-top,
   herdado da regra base de #app acima, para que o conteúdo comece
   exatamente abaixo da Dynamic Island. */
body.is-ios.route-home #app {
  padding-top: 0;
}
body.is-ios .v-app-bar.landing-header-desktop-wrap,
body.is-ios .v-app-bar.landing-header-mobile-wrap {
  margin-top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  max-width: none !important;
  border-radius: 0 !important;
}
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #F15A24 #f0f0f0;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #f0f0f0;
}

*::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
  border-radius: 20px;
  border: 3px solid #f0f0f0;
}

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

.inter {
    font-family: "Inter", sans-serif;
}

.mylegis {
  font-family: "Inter", 'Trebuchet MS', Arial, sans-serif !important;
}

.v-application {
  font-family: "Inter" !important;
}

.v-text-field .v-input__prepend-inner,
.v-text-field .v-input__append-inner {
  align-self: auto !important;
}

.gt-bold {
  font-weight: 600
}


.my-orange {
  color: #F15A24
}

.overlay {
  color: #fff;
  background-color: #00000075 !important;
}

.gt-tag {
  position: relative;
  display:flex;
  justify-content:center;
  align-items:center;
  width: 310px;
  height: 45px;
  border-radius:5px;
}
small {
  font-size: 90% !important;
}
.gt-tag h4 {
  font-size: 22px;
  color: white;

}
.w-100 { 
  width:100%;
}

.btn:hover .v-icon.v-icon,
.btn-tertiary:hover .v-icon.v-icon {
  color: #de002e !important;
}

.btn-tertiary:hover .v-image {
  filter: invert(24%) sepia(97%) saturate(7470%) hue-rotate(338deg) brightness(80%) contrast(123%);

}

.btn-secondary:hover .v-icon.v-icon {
  color: white !important;
}

.tag-checkbox:checked+.tag-container {
  border-color: #4f2d7f !important;
  background-color: #4f2d7f !important;
  color: #cbc4bc !important;
}

.tag-checkbox:checked+.tag-container .tag-icon::before,
.tag-checkbox:checked+.tag-container .tag-icon::after {
  background-color: #cbc4bc !important;
}
.ql-snow .ql-tooltip {
	left: 290px !important;
  top: -50px !important;
}
.v-input__prepend-outer {
  margin: 0px !important;
}
.v-input {
  justify-content: center;
}

#list-31 { 
  width:510;
}
.v-slide-group__next, .v-slide-group__prev { 
  min-width:24px !important;
}
</style>
<script>
    import FloatingChat from "./components/FloatingChat.vue";

export default {
  name: "App",
  components: {
    FloatingChat,
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const isHome = route && (route.name === 'home' || route.path === '/');
        document.body.classList.toggle('route-home', !!isHome);
      },
    },
  },
  methods: {
    reloadPage() {
      window.location.reload(true);
    },
  },
}
</script>